import { ICurriculum } from "../model";

export const curriculumInitial: ICurriculum = {
  title: "",
  curriculumTypeId:0,
  gradeLevelId:0,
  schoolId:0,
  active:false,
  useAllSameGradeLevel:false,
  createdUserId:0,
  languageCode:"tr-TR",
  organizationId:0,
  curriculumDetail:[]
};